import {
  AcceptOrderRequest,
  AcceptOrderRequestToJSON,
  CancelOrdersRequest,
  CancelOrderRequestToJSON,
  DeleteOrderRequestToJSON,
  DeleteOrdersRequest,
  HTTPBody,
  Order,
  OrderFromJSON,
  UpdateOrderRequest,
  UpdateOrderRequestToJSON,
  OrderMemoFromJSON,
  OrderMemo,
  SimpleAcceptOrderRequest,
  SimpleAcceptOrderResponse,
  SimpleAcceptOrderRequestToJSON,
  SimpleAcceptOrderResponseFromJSON
} from '@/api'
import {
  UpdateOrderMemoRequest,
  UpdateOrderMemoRequestToJSON
} from '@/api/models/order/UpdateOrderMemoRequest'
import {
  AcceptOrderReceipt,
  AcceptOrderReceiptFromJSON
} from '@/api/models/accept-order/AcceptOrderReceipt'
import * as runtime from '../runtime'

export interface GetOrderMemoRequest {
  orderId: number
}

export class OrderApi extends runtime.BaseAPI {
  /**
   * 発注を取得する
   * 発注取得
   */
  async getOrder(id: number | string): Promise<Order> {
    const response = await this.requestGet(`/orders/${id}`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      OrderFromJSON(jsonValue)
    ).value()
  }

  /**
   * 発注資料を更新する
   * 発注資料更新
   */
  async updateOrder(
    request: UpdateOrderRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = UpdateOrderRequestToJSON(request)

    const response = await this.requestPut(
      `/orders/${request.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 発注を受け入れる
   * 発注受入
   */
  async acceptOrder(request: AcceptOrderRequest): Promise<AcceptOrderReceipt> {
    const bodyParameters: HTTPBody = AcceptOrderRequestToJSON(request)

    const response = await this.requestPost(
      `/orders/${request.id}/accept`,
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      AcceptOrderReceiptFromJSON(jsonValue)
    ).value()
  }

  /**
   * 発注を取り消す
   * 発注取消
   */
  async cancelOrders(
    request: CancelOrdersRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = CancelOrderRequestToJSON(request)

    const response = await this.requestPut('/orders/cancel', bodyParameters)

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 発注を削除する
   * 発注削除
   */
  async deleteOrders(
    request: DeleteOrdersRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = DeleteOrderRequestToJSON(request)

    const response = await this.requestDelete('/orders', bodyParameters)

    return new runtime.VoidApiResponse(response)
  }

  /**
   *  発注IDにより発注メモを取得する
   *  発注メモ取得
   */
  async getOrderMemoById(request: GetOrderMemoRequest): Promise<OrderMemo> {
    const response = await this.requestGet(`/orders/${request.orderId}/memo`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      OrderMemoFromJSON(jsonValue)
    ).value()
  }

  /**
   * 入力値により発注資料のメモを更新する
   * 発注メモ更新
   */
  async updateOrderMemo(
    requestBody: UpdateOrderMemoRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = UpdateOrderMemoRequestToJSON(requestBody)

    const response = await this.requestPost(
      `/orders/${requestBody.id}/memo`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 発注を受け入れる
   * 発注受入
   */
  async simpleAcceptOrder(
    request: SimpleAcceptOrderRequest
  ): Promise<SimpleAcceptOrderResponse> {
    const bodyParameters: HTTPBody = SimpleAcceptOrderRequestToJSON(request)

    const response = await this.requestPost(
      `/orders/${request.id}/simple-accept`,
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      SimpleAcceptOrderResponseFromJSON(jsonValue)
    ).value()
  }
}
